import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function LegalLayout({ title, effectiveDate, children, testId }) {
    return (
        <div data-testid={testId} className="min-h-screen bg-[#FAFAFA]">
            <Header />
            <section className="pt-32 md:pt-40 pb-16 bg-white border-b border-slate-200">
                <div className="max-w-3xl mx-auto px-6 md:px-10">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">FilesCAD Legal</div>
                    <h1 className="mt-4 font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter text-slate-950">
                        {title}
                    </h1>
                    {effectiveDate && (
                        <p className="mt-4 text-sm text-slate-500 font-mono">
                            Effective Date: {effectiveDate}
                        </p>
                    )}
                </div>
            </section>
            <section className="py-16 md:py-20">
                <div className="max-w-3xl mx-auto px-6 md:px-10">
                    <article className="prose-legal text-slate-700 leading-relaxed space-y-6">
                        {children}
                    </article>
                </div>
            </section>
            <Footer />
        </div>
    );
}
